enum Outlet
{
	T13 = 1,
	T25 = 2,
	CEE16230 = 3,
	CEE16400 = 4,
	CEE32400 = 5
}

export default Outlet;